import { getPostalCodeIsUsableForGeoCodes } from 'cart-core';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFindCurrentCountryRuleQuery, useFindGeoCodesQuery } from '../api';
import { selectShippingPostalCode } from '../slices/shipping';

/**
 * Returns query for geo codes based on the current shipping postal code if they are available
 *
 * Will skip as long as the current postal code is unusable or when the current
 * country rules does not require geo codes.
 */
const useGeoCodesByShippingQuery = () => {
    const postalCode = useSelector(selectShippingPostalCode);
    const countryRulesQuery = useFindCurrentCountryRuleQuery();
    // NOTE: It is important to memoize the filter here because use*Query() only
    //       does a shallow comparison on it. If you don't, the filter object
    //       will be new every render, which will result in an infinite update
    //       loop that will severely lag the browser.
    const filter = useMemo(() => ({ where: { zip: postalCode }}), [postalCode]);
    const geoCodesQuery = useFindGeoCodesQuery(filter, { skip: (
        !countryRulesQuery.data?.geoCodeRequired ||
        !getPostalCodeIsUsableForGeoCodes(postalCode)
    ) });

    return geoCodesQuery;
}

export default useGeoCodesByShippingQuery;
